"use client";
import { useState, useEffect } from "react";
import Link from "next/link";
import { textFormat } from "../../tools/helper";

export default function Citation() {
  const [loading, setLoading] = useState(true);
  const [citation, setCitation] = useState([]);

  const fetchCitation = async () => {
    var bodyFormData = new URLSearchParams();

    const res = await fetch(
      process.env.NEXT_PUBLIC_API_URL + "/api/commentaires/citations",
      {
        method: "POST",
        body: bodyFormData,
        // headers: { "User-Agent": "Choualbox Next" },
      }
    );
    let response = await res.json();

    if (response.status == "200") {
      setCitation(response.data);
      // console.log(response);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (loading) fetchCitation();
  }, [loading]);

  return loading ? (
    ""
  ) : citation?.com_texte != null ? (
    <div className="text-base-content opacity-80 sm:w-1/3 sm:mx-auto">
      <blockquote className="border-l-4 border-secondary pl-2 bg-base-100 py-2">
        <p
          className={`super-break-words`}
          dangerouslySetInnerHTML={{
            __html: textFormat({ html: true, text: citation.com_texte }),
          }}
        ></p>
        <cite className="block text-sm mt-4 opacity-70">
          <Link
            href={`/blog/` + citation.membre_permalink}
            className="font-bold"
          >
            {citation.membre_pseudo}
          </Link>
          , le {citation.date} dans
          <Link href={`/` + citation.box_permalink} className="font-bold">
            <p
              className={`text-sm super-break-words`}
              dangerouslySetInnerHTML={{
                __html: textFormat({ html: true, text: citation.box_titre }),
              }}
            ></p>
          </Link>
        </cite>
      </blockquote>
    </div>
  ) : null;
}
